module.exports = __webpack_public_path__ + "img/Z61_01.cd3db193.jpg";